import { assign, DoneEventObject, Machine } from "xstate";
import { QueryError } from "../../../../../microservices/functions/src/product_catalog/event_listeners/application_response";
import { CategoryDetailResult } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { fetchCategoryDetail } from "../api/product_catalog_api";

type CategoryDetailContext = {
  categoryId: number;
  baseUrl: string;
  category?: CategoryDetailResult;
  error?: QueryError;
};

export type RetryLoading = {
  type: "RETRY";
};

type CategoryDetailEvent = RetryLoading;

export const CategoryDetailMachine = Machine<
  CategoryDetailContext,
  CategoryDetailEvent
>(
  {
    id: "categoryDetail",
    initial: "loadingDetail",
    states: {
      loadingDetail: {
        invoke: {
          id: "fetchCategoryDetail",
          src: "fetchCategoryDetail",
          onDone: {
            target: "displayed",
            actions: ["assignCategoryDetailResult"],
          },
          onError: {
            target: "loadingFailed",
            actions: "assignError",
          },
        },
      },
      displayed: {},
      loadingFailed: {
        on: {
          RETRY: {
            target: "loadingDetail",
            actions: "removeError",
          },
        },
      },
    },
  },
  {
    actions: {
      assignError: assign({
        error: (context, event: any) => ({
          message: event.data?.message ?? "Unknown error",
          details: event.data?.details ?? {},
        }),
      }),
      removeError: assign({
        error: (_context, _event) => undefined,
      }),
      assignCategoryDetailResult: assign({
        category: (context, event) => (event as DoneEventObject).data,
      }),
    },
    services: {
      fetchCategoryDetail: (context, _event) =>
        fetchCategoryDetail(context.baseUrl, context.categoryId),
    },
  }
);
